import { matchPath } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import routes from '../routers';
import { requiresDocumentDeletePermission } from './documentDeletePermissions';

const _ignoredRoutes = ['/', '/change-password'];
const normalizePermission = (value) => `${value || ''}`.trim().toUpperCase();

function useVerifyAccess(props) {
  const { user } = useAuth();
  const isAdministrator = Number(user?.isAdministrator) === 1;
  const getUserAuth = () => {
    return user;
  };

  const verifyPermission = (permission, any = false, options = {}) => {
    const requireAssigned = Boolean(options?.requireAssigned) || requiresDocumentDeletePermission(permission);
    if (isAdministrator && !requireAssigned) return true;
    const permissions = (permission instanceof Array ? permission : [permission]).map(normalizePermission).filter(Boolean);
    if (!permissions.length) return false;

    const { functions = [] } = getUserAuth() || {};
    const functionSet = new Set((functions ?? []).map(normalizePermission).filter(Boolean));
    return any
      ? permissions.some((_permission) => functionSet.has(_permission))
      : permissions.every((_permission) => functionSet.has(_permission));
  };

  const verify = (route, location) => {
    let user = getUserAuth() || null;
    let verify = null;
    let ignoredRoute = null;
    if (user) {
      if (!route && location) {
        route = routes.find((_route) => {
          let result = matchPath(location.pathname, _route);
          return !!result;
        });
      }

      if (route) {
        ignoredRoute = _ignoredRoutes.find((_pathname) => {
          let result = matchPath(_pathname, route);
          return !!result;
        });
      }

      const requireAssigned = Boolean(route?.requireAssigned) || requiresDocumentDeletePermission(route?.function);
      if (route && !ignoredRoute && (!isAdministrator || requireAssigned)) {
        if (route.allowLoggedIn) return true;

        let _function = verifyPermission(route.function, route.any, { requireAssigned });
        if (!_function) {
          verify = 'access_denined';
        }
      }
    }
    return verify || (user ? true : false);
  };

  return { verify, verifyPermission };
}

export default useVerifyAccess;
